import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  html,
  body {
    height: 100%;
    width: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0.06);
  }
  a{
    text-decoration:none;
    color: #222;
  }
  a:hover, a:focus{
    text-decoration:none;
    color: #000;
  }

  /* Search DatePicker panels — charcoal selection (not brand pink). */
  .ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-today
    .ant-picker-cell-inner::before {
    border-color: #222222 !important;
  }
  .ant-picker-dropdown
    .ant-picker-cell-in-view.ant-picker-cell-selected
    .ant-picker-cell-inner,
  .ant-picker-dropdown
    .ant-picker-cell-in-view.ant-picker-cell-range-start
    .ant-picker-cell-inner,
  .ant-picker-dropdown
    .ant-picker-cell-in-view.ant-picker-cell-range-end
    .ant-picker-cell-inner {
    background: #222222 !important;
    color: #fff !important;
  }
  .ant-picker-dropdown
    .ant-picker-cell-in-view.ant-picker-cell-selected:hover
    .ant-picker-cell-inner {
    background: #000000 !important;
  }
  .ant-picker-dropdown .ant-picker-today-btn {
    color: #222222 !important;
  }
  .ant-picker-dropdown .ant-picker-header-view button:hover {
    color: #222222 !important;
  }
  .ant-picker-dropdown .ant-picker-cell:hover:not(.ant-picker-cell-selected):not(
      .ant-picker-cell-disabled
    )
    .ant-picker-cell-inner {
    background: #f7f7f7 !important;
  }
  #app {
    background-color: #fafafa;
    min-height: 100%;
    min-width: 100%;
    .ant-layout{
      background:white;
    }
  }

  .site-layout {
    min-height: 100vh;
    min-height: 100dvh;
    display: flex;
    flex-direction: column;
  }

  .site-layout .site-main-content {
    flex: 1 0 auto;
    width: 100%;
  }

  /* Compact search pill: sit content closer to header; expanded search keeps measured offset. */
  .site-main-content--compact-search .image-Gallery {
    margin-top: 0;
  }

  .site-main-content--compact-search .image-Gallery > div {
    margin-top: 0;
  }

  .site-layout .ant-layout-footer {
    flex-shrink: 0;
  }
  /* Helper classes */
  .primary-clr{
    color:#FF385C;
    :hover{
      color:#E61E4D;
    }
  }
  /* Leaflet: default to filling its parent; fullscreen modes override below */
  .leaflet-container {
    width: 100%;
    max-width: 100%;
    height: 100%;
  }

  .results-filter-dropdown {
    z-index: 1200 !important;
  }

  .results-filter-dropdown .ant-dropdown-menu {
    border-radius: 12px;
    border: 1px solid #ddd;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
    overflow: hidden;
    margin-top: 4px;
  }

  .results-cuisine-menu {
    max-height: min(50vh, 320px);
    overflow-y: auto;
    padding: 4px 0;
  }

  .ant-select-dropdown.results-filter-dropdown {
    z-index: 1200 !important;
    border-radius: 12px;
    border: 1px solid #ddd;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
  }

  .search-form-dropdown {
    z-index: 1200 !important;
  }

  @media (max-width: 768px) {
    .search-form-dropdown .ant-select-search__field,
    .ant-select-dropdown.search-form-dropdown input {
      font-size: 16px !important;
    }

    .ant-picker-dropdown .ant-picker-input > input,
    .ant-picker-dropdown input {
      font-size: 16px !important;
    }
  }

  .header-account-dropdown {
    z-index: 1300 !important;
  }

  .header-account-dropdown .ant-dropdown-menu {
    border-radius: 12px;
    border: 1px solid #ebebeb;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    overflow: hidden;
    margin-top: 8px;
    min-width: 240px;
    padding: 6px;
  }

  .header-account-dropdown .ant-dropdown-menu-item {
    min-height: 44px;
    line-height: 1.35;
    padding: 8px 10px;
    font-size: 14px;
    border-radius: 8px;
  }

  .header-account-dropdown .ant-dropdown-menu-item-divider {
    margin: 6px 4px;
    background-color: #ebebeb;
  }

  .header-account-menu-item {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    color: rgba(0, 0, 0, 0.88);
  }

  .header-account-menu-icon {
    font-size: 17px;
    color: #484848;
    flex-shrink: 0;
  }

  .header-account-menu-text {
    flex: 1;
    font-weight: 500;
  }

  .header-account-dropdown
    .header-account-menu-logout-item
    .header-account-menu-icon,
  .header-account-dropdown
    .header-account-menu-logout-item
    .header-account-menu-text {
    color: #ff4d4f;
  }

  .header-account-dropdown .ant-dropdown-menu-item:hover {
    background: #f7f7f7;
  }

  .header-account-dropdown .header-account-menu-logout-item:hover {
    background: #fff1f0;
  }

  .header-account-dropdown .header-account-menu-logout-item:hover
    .header-account-menu-icon,
  .header-account-dropdown .header-account-menu-logout-item:hover
    .header-account-menu-text {
    color: #ff4d4f;
  }

  .auth-modal .login-field-password.ant-form-item {
    margin-bottom: 8px;
  }

  .auth-modal .signup-phone-form-item .ant-form-item-label {
    margin-bottom: 8px;
    padding: 0;
  }

  .auth-modal .signup-phone-form-item .ant-form-item-label > label {
    display: block;
    height: auto;
    width: 100%;
  }

  .auth-modal .signup-phone-heading {
    display: block;
    margin-bottom: 4px;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.35;
    color: rgba(0, 0, 0, 0.88);
  }

  .auth-modal .signup-phone-hint {
    display: block;
    margin-top: 0;
  }

  .auth-modal .signup-phone-form-item .react-tel-input.signup-phone-input {
    display: block;
    width: 100%;
  }

  .auth-modal .signup-phone-input .form-control.signup-phone-input-field {
    width: 100% !important;
    max-width: 100%;
    height: 40px;
    padding-left: 48px;
    font-size: 16px;
    line-height: 1.5;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    box-sizing: border-box;
  }

  .auth-modal .signup-phone-input .flag-dropdown.signup-phone-input-button {
    border: 1px solid #d9d9d9;
    border-right: none;
    border-radius: 6px 0 0 6px;
    background: #fff;
  }

  .auth-modal .signup-phone-input .selected-flag {
    width: 42px;
    padding: 0 0 0 8px;
    border-radius: 6px 0 0 6px;
  }

  .auth-modal .signup-phone-input .selected-flag:hover,
  .auth-modal .signup-phone-input .selected-flag:focus {
    background: #fff;
  }

  .auth-modal .signup-phone-input .country-list.signup-phone-input-dropdown {
    z-index: 1500;
    max-width: min(100vw - 32px, 360px);
  }

  .auth-modal .signup-phone-input .form-control.signup-phone-input-field:focus {
    border-color: #b0b0b0;
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.04);
  }

  /* Soft focus for form controls — avoid harsh black / error-like pink. */
  .ant-input:focus,
  .ant-input-focused,
  .ant-input-affix-wrapper:focus,
  .ant-input-affix-wrapper-focused,
  .ant-input-outlined:focus,
  .ant-input-outlined.ant-input-focused,
  .ant-input-affix-wrapper-outlined:focus,
  .ant-input-affix-wrapper-outlined.ant-input-affix-wrapper-focused,
  .ant-select-focused .ant-select-selector,
  .ant-picker-focused,
  .ant-input-number-focused,
  .ant-input-number:focus-within {
    border-color: #b0b0b0 !important;
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.04) !important;
  }

  .auth-modal .ant-modal-body {
    padding-bottom: 16px;
  }

  .auth-modal .ant-btn.primary-btn:not(:disabled),
  .auth-modal button.primary-btn:not(:disabled) {
    border: none !important;
    border-color: transparent !important;
    background: radial-gradient(circle at center, #FF385C 0%, #E61E4D 100%) !important;
    color: #fff !important;
    box-shadow: 0 2px 8px rgba(230, 30, 77, 0.28);
  }

  .auth-modal .ant-btn.primary-btn:not(:disabled):hover,
  .auth-modal .ant-btn.primary-btn:not(:disabled):focus,
  .auth-modal button.primary-btn:not(:disabled):hover,
  .auth-modal button.primary-btn:not(:disabled):focus {
    border: none !important;
    border-color: transparent !important;
    background: radial-gradient(circle at center, #FF385C 0%, #E61E4D 100%) !important;
    color: #fff !important;
    filter: brightness(0.96);
    box-shadow: 0 4px 12px rgba(230, 30, 77, 0.36);
  }

  @media (max-width: 768px) {
    .auth-modal .ant-modal-body {
      padding-bottom: 12px;
    }
  }

  .payment-method-modal.ant-modal-wrap {
    z-index: 1400 !important;
    align-items: flex-start !important;
    padding-top: 80px !important;
    padding-bottom: 24px !important;
    overflow-y: auto;
  }

  .payment-method-modal .ant-modal-mask {
    z-index: 1400 !important;
  }

  .payment-method-modal .ant-modal {
    max-width: calc(100vw - 32px) !important;
    top: auto !important;
    margin: 0 auto;
    padding-bottom: 0;
    max-height: calc(100vh - 104px);
  }

  .payment-method-modal .ant-modal-content {
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.12);
    max-height: calc(100vh - 104px);
    display: flex;
    flex-direction: column;
  }

  .payment-method-modal .ant-modal-header {
    border-bottom: none;
  }

  .payment-method-modal .ant-modal-title {
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    width: 100%;
    color: #222;
    line-height: 1.3;
  }

  .payment-method-modal .ant-modal-close {
    top: 18px;
    inset-inline-end: 18px;
    color: #222;
  }

  .payment-method-modal .ant-modal-close:hover {
    color: #222;
    background: #f7f7f7;
  }

  .payment-method-modal .payment-method-card-form .StripeElement {
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
    padding: 0 !important;
    margin: 0 !important;
    min-height: 24px;
  }

  .payment-method-modal .payment-method-card-form .stripe-slot {
    min-height: 28px;
    position: relative;
    z-index: 2;
    pointer-events: auto;
  }

  .payment-method-modal .payment-method-card-form iframe {
    pointer-events: auto !important;
    min-height: 28px !important;
  }

  .payment-method-modal .payment-method-card-form .StripeElement {
    pointer-events: auto !important;
  }

  .payment-method-modal .ant-modal-body {
    overflow: visible;
  }

  @media (max-width: 768px) {
    .payment-method-modal.ant-modal-wrap {
      padding-top: 64px !important;
    }

    .payment-method-modal .ant-modal-body {
      padding: 12px 20px 20px !important;
    }

    .payment-method-modal .ant-modal-header {
      padding: 20px 20px 0 !important;
    }
  }

  .ant-select-dropdown.search-form-dropdown .rc-virtual-list-holder {
    max-height: min(50vh, 320px) !important;
  }

  .ant-picker-dropdown.search-form-dropdown,
  .ant-picker-dropdown {
    z-index: 1200 !important;
  }

  /* Search calendar — compact panel on desktop. */
  @media (min-width: 769px) {
    .ant-picker-dropdown.search-datepicker-popup .ant-picker-panel-container,
    .search-datepicker-popup.ant-picker-dropdown .ant-picker-panel-container,
    .ant-picker-dropdown:has(.search-datepicker-panel) .ant-picker-panel-container {
      width: auto !important;
      max-width: 360px !important;
    }

    .ant-picker-dropdown:has(.search-datepicker-panel) .search-datepicker-panel,
    .search-datepicker-popup .search-datepicker-panel {
      width: 320px !important;
      max-width: 320px !important;
    }

    .ant-picker-dropdown:has(.search-datepicker-panel) .ant-picker-panel,
    .ant-picker-dropdown:has(.search-datepicker-panel) .ant-picker-date-panel,
    .search-datepicker-popup .ant-picker-panel,
    .search-datepicker-popup .ant-picker-date-panel {
      width: 320px !important;
      max-width: 320px !important;
    }
  }

  /* Search calendar — full-bleed bottom sheet on small screens. */
  @media (max-width: 768px) {
    .ant-picker-dropdown.search-datepicker-popup,
    .search-datepicker-popup.ant-picker-dropdown,
    .ant-picker-dropdown:has(.search-datepicker-panel) {
      position: fixed !important;
      inset: auto 0 0 0 !important;
      top: auto !important;
      right: 0 !important;
      bottom: 0 !important;
      left: 0 !important;
      width: 100vw !important;
      max-width: 100vw !important;
      min-width: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      transform: none !important;
      overflow-x: hidden !important;
      pointer-events: auto !important;
      z-index: 1300 !important;
    }

    .ant-picker-dropdown.search-datepicker-popup .ant-picker-panel-container,
    .search-datepicker-popup.ant-picker-dropdown .ant-picker-panel-container,
    .ant-picker-dropdown:has(.search-datepicker-panel) .ant-picker-panel-container {
      width: 100% !important;
      max-width: 100vw !important;
      min-width: 0 !important;
      border-radius: 16px 16px 0 0;
      box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.14);
      overflow-x: hidden;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      padding-bottom: max(12px, env(safe-area-inset-bottom, 0px));
      max-height: min(85dvh, 640px);
      box-sizing: border-box;
    }

    .ant-picker-dropdown:has(.search-datepicker-panel) .search-datepicker-panel,
    .search-datepicker-popup .search-datepicker-panel {
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      box-sizing: border-box;
    }

    .ant-picker-dropdown:has(.search-datepicker-panel) .ant-picker-panel-layout,
    .ant-picker-dropdown:has(.search-datepicker-panel) .ant-picker-panels,
    .ant-picker-dropdown:has(.search-datepicker-panel) .ant-picker-panel,
    .ant-picker-dropdown:has(.search-datepicker-panel) .ant-picker-date-panel,
    .search-datepicker-popup .ant-picker-panel-layout,
    .search-datepicker-popup .ant-picker-panels,
    .search-datepicker-popup .ant-picker-panel,
    .search-datepicker-popup .ant-picker-date-panel {
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      border-inline-end: none !important;
      box-sizing: border-box;
    }

    .ant-picker-dropdown:has(.search-datepicker-panel) .ant-picker-content,
    .search-datepicker-popup .ant-picker-content {
      width: 100% !important;
      max-width: 100% !important;
      table-layout: fixed !important;
    }

    .ant-picker-dropdown:has(.search-datepicker-panel) .ant-picker-content th,
    .ant-picker-dropdown:has(.search-datepicker-panel) .ant-picker-content td,
    .search-datepicker-popup .ant-picker-content th,
    .search-datepicker-popup .ant-picker-content td {
      min-width: 0 !important;
      width: 14.28% !important;
      padding: 1px 0 !important;
    }

    .ant-picker-dropdown:has(.search-datepicker-panel) .ant-picker-cell,
    .search-datepicker-popup .ant-picker-cell {
      min-width: 0 !important;
      padding: 0 !important;
    }

    .ant-picker-dropdown:has(.search-datepicker-panel) .ant-picker-cell-inner,
    .search-datepicker-popup .ant-picker-cell-inner {
      min-width: 32px !important;
      width: 32px !important;
      height: 32px !important;
      line-height: 32px !important;
      margin-inline: auto !important;
      font-size: 13px !important;
    }

    .ant-picker-dropdown:has(.search-datepicker-panel) .ant-picker-header,
    .search-datepicker-popup .ant-picker-header {
      padding: 8px 10px !important;
    }

    .ant-picker-dropdown:has(.search-datepicker-panel) .ant-picker-body,
    .search-datepicker-popup .ant-picker-body {
      padding: 4px 8px 16px !important;
    }

    .ant-picker-dropdown:has(.search-datepicker-panel) .ant-picker-footer,
    .search-datepicker-popup .ant-picker-footer {
      display: none !important;
    }
  }

 .ant-switch-checked {
    background: #FF385C;
    font-weight:bold;
  }
  .ant-switch{
  height:30px;
  line-height:25px;
  width:145px;
  font-weight:bold;
  }
  .ant-switch-loading-icon, .ant-switch:after{
  width:22px;
  height:22px;
  top:2px;
  }

  .bg-primary{
    background:#FF385C;
  }
  .white-clr{
    color: #fff;
  }
  .height-500{
    height: 500px;
  }
  .mar-btm-10{
    margin-bottom:10px !important;
  }
  .mar-btm-0{
    margin-bottom:0 !important;
  }
  .margin-filter{
    margin:12px 0;
  }
  /* common styles */
  .ant-rate-star {
    margin-right: 5px;
    svg {
      width: 15px;
      height: 15px;
    }
    @media (max-width:1300px){
      margin-right: 2px;
      svg {
        width: 12px;
        height: 12px;
      }
    }
  }
  .primary-btn{
    font-weight: 600;
    border-color: transparent;
    transition: filter 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease;
    background: radial-gradient(circle at center, #FF385C 0%, #E61E4D 100%);
    color: white;
    box-shadow: 0 2px 8px rgba(230, 30, 77, 0.28);
    :hover,
    :focus {
      border-color: transparent;
      background: radial-gradient(circle at center, #FF385C 0%, #E61E4D 100%);
      color: white;
      filter: brightness(0.96);
      box-shadow: 0 4px 12px rgba(230, 30, 77, 0.36);
    }
  }

  .ant-btn.primary-btn:not(.filter-scroll):not(:disabled),
  .ant-btn-primary.primary-btn:not(.filter-scroll):not(:disabled),
  button.primary-btn:not(.filter-scroll):not(:disabled) {
    border: none !important;
    border-color: transparent !important;
    background: radial-gradient(circle at center, #FF385C 0%, #E61E4D 100%) !important;
    color: #fff !important;
    box-shadow: 0 2px 8px rgba(230, 30, 77, 0.28);
  }

  .ant-btn.primary-btn:not(.filter-scroll):not(:disabled):hover,
  .ant-btn.primary-btn:not(.filter-scroll):not(:disabled):focus,
  .ant-btn-primary.primary-btn:not(.filter-scroll):not(:disabled):hover,
  .ant-btn-primary.primary-btn:not(.filter-scroll):not(:disabled):focus,
  button.primary-btn:not(.filter-scroll):not(:disabled):hover,
  button.primary-btn:not(.filter-scroll):not(:disabled):focus {
    border: none !important;
    border-color: transparent !important;
    background: radial-gradient(circle at center, #FF385C 0%, #E61E4D 100%) !important;
    color: #fff !important;
    filter: brightness(0.96);
    box-shadow: 0 4px 12px rgba(230, 30, 77, 0.36);
  }

  .filter-scroll .ant-btn.primary-btn,
  .filter-scroll button.primary-btn {
    border-color: #222 !important;
    background: #f7f7f7 !important;
    color: #222 !important;
    font-weight: 500;
  }

  .filter-scroll .ant-btn.primary-btn:hover,
  .filter-scroll .ant-btn.primary-btn:focus,
  .filter-scroll button.primary-btn:hover,
  .filter-scroll button.primary-btn:focus {
    border-color: #222 !important;
    background: #f0f0f0 !important;
    color: #222 !important;
  }

  .filter-scroll .ant-btn.filter-chip-selected,
  .filter-scroll button.filter-chip-selected {
    border-color: #222 !important;
    background: #f7f7f7 !important;
    color: #222 !important;
    font-weight: 500;
  }

  .filter-scroll .ant-btn.filter-chip-selected:hover,
  .filter-scroll .ant-btn.filter-chip-selected:focus,
  .filter-scroll button.filter-chip-selected:hover,
  .filter-scroll button.filter-chip-selected:focus {
    border-color: #222 !important;
    background: #f0f0f0 !important;
    color: #222 !important;
  }
  .Booked{
    background : red !important;
  }
  .loader{
    text-align: center;
    background: rgba(0,0,0,0.05);
    border-radius: 4px;
    margin-bottom: 20px;
    padding: 30px 50px;
    margin: 20px 0;
  }
  .ant-radio-checked{
    :after{
      border: 1px solid #E61E4D !important;
    }
    .ant-radio-inner{
      border-color:#E61E4D !important;
      :after{
      background:#FF385C !important;
      }
    }
  }
  /* Ant Design 6: checkmark lives on .ant-checkbox::after (no .ant-checkbox-inner). */
  .ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover .ant-checkbox:not(.ant-checkbox-disabled),
  .ant-checkbox:not(.ant-checkbox-disabled):hover {
    border-color: #FF385C;
  }

  .ant-checkbox-checked:not(.ant-checkbox-disabled) {
    background: #FF385C !important;
    border-color: #FF385C !important;
  }

  .ant-checkbox-checked:not(.ant-checkbox-disabled)::after {
    border-color: #fff !important;
    opacity: 1 !important;
    transform: rotate(45deg) scale(1) translate(-50%, -50%) !important;
  }

  .ant-checkbox-disabled.ant-checkbox-checked {
    background: rgba(0, 0, 0, 0.04) !important;
  }
  .whole-views.ant-modal-wrap {
    z-index: 1400 !important;
  }

  .whole-views{
    .ant-modal-body  {
      padding:0px;
    }
  }

  .booking-card-datepicker {
    .ant-calendar-disabled-cell .ant-calendar-date .booked{
      background: #ff0000 !important;
      color: #fff !important;
    }
    .ant-calendar-date {
      background: #FF385C ;
      color: white ;
    }
    .ant-calendar-disabled-cell .ant-calendar-date {
      cursor: not-allowed;
      color: rgba(0, 0, 0, 0.25);
      background: #f5f5f5 !important ;
      border-radius: 0;
      width: auto;
      border: 1px solid transparent;
      margin: 0 1px !important;
    }
     .ant-calendar-today-btn {
      display: none !important;
    }
  }
  .booking-popup{
    .ant-popover-inner{
      background: red;
      .ant-popover-inner-content{
        color: white !important;
      }
    }
    .ant-popover-arrow{
      border-right-color: red !important;
      border-bottom-color: red !important;
    }
  }
  .venues-drop-down{
    padding: 1rem 1.5rem ;
    .ant-checkbox-wrapper{
      display: block;
      margin-bottom: 10px;
      margin-left:0;

    }
    p {
      display: inline-flex;
      flex-flow:row wrap;
      padding-left:0;
      margin:0;
    }
    .text-center{
      display: flex;
      justify-content: center;
    }

    .ant-slider-track,
    .ant-slider-handle,
    .ant-slider-handle.ant-tooltip-open,
    .ant-slider-handle:focus {
      background-color: #FF385C !important;
      border-color: #FF385C !important;
    }
    .ant-checkbox-wrapper + span, .ant-checkbox + span {
      padding-left: 0.5rem !important;
    }
    @media(max-width:767px){
      .ant-checkbox-wrapper{
        display: flex;
      }
      .ant-checkbox{
        margin-top:5px;
      }
    }
  }
  .venue-category-drop-down{
    .ant-checkbox-wrapper{
      display: inline-flex !important;
      align-items: flex-start;
      margin-bottom: 0 !important;
    }
    .ant-checkbox{
      margin-top: 0 !important;
    }
    .ant-checkbox + span{
      display: none;
    }
  }
  .map.vendor-map-card {
    z-index: 1200 !important;

    .ant-modal {
      max-width: min(640px, calc(100vw - 32px)) !important;
      padding-bottom: 0;
    }

    .ant-modal-body {
      padding: 0 0 4px !important;
    }
  }
  .Booked{
    background : red !important;
  }
  #lightboxBackdrop{
    svg{
      path{
        color:white
      }
    }
  }
  .gallery-control ,.gallery-close{
    :focus{
      outline:none
    }
  }
  input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.filter-heading{
  display: 'inline-block';
  margin: '0 0.9rem';
  @media(max-width:767px){
    margin:0;
    margin-bottom:10px;
  }
}
.popup-form {
  h3{
    margin-bottom:0;
  }
  .ant-form-item-label{
    text-align:left;
    white-space:normal;
    line-height:25px;
    margin-bottom:15px;
    label:after{
      display:none !important;
    }
  }
}

  .auth-modal .signup-form.ant-form-vertical .ant-form-item-label {
    margin-bottom: 6px;
  }

  .auth-modal .signup-agreement-form-item {
    margin-bottom: 12px;
  }

  .auth-modal .signup-agreement-form-item .ant-form-item-control-input {
    min-height: auto;
  }

  .auth-modal .signup-agreement-checkbox.ant-checkbox-wrapper {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-inline-start: 0;
    line-height: 1.45;
  }

  .auth-modal .signup-agreement-checkbox .ant-checkbox {
    margin-top: 2px;
    flex-shrink: 0;
  }

  .auth-modal .signup-agreement-checkbox .ant-checkbox + span {
    padding-inline-start: 0;
    padding-inline-end: 0;
  }

  .auth-modal .signup-agreement-text {
    display: inline;
    font-size: 12px;
    line-height: 1.45;
    color: rgba(0, 0, 0, 0.88);
  }

  .auth-modal .signup-agreement-text a {
    font-weight: 600;
    color: #222222;
    text-decoration: underline;
    text-underline-offset: 2px;
  }

  .auth-modal .signup-agreement-text a:hover,
  .auth-modal .signup-agreement-text a:focus {
    color: #000000;
  }
@media (max-width: 576px) {
    .ant-layout-footer {
      padding: 24px 4px !important;
    }
  }

#google_translate_element {
  position: fixed !important;
  top: 0 !important;
  left: 8% !important;
  z-index: 1111111111111 !important;
  .skiptranslate{
    color:transparent !important;
    .goog-te-combo{
      color:black !important;
      font-size:16px !important;
      border:1px solid;
      height:35px;
      margin-top:17px;
    }
    span{
      display:none !important;
    }
  }
}
`;

export default GlobalStyle;
